import { render, staticRenderFns } from "./collection-list.vue?vue&type=template&id=38247ee2&"
import script from "./collection-list.vue?vue&type=script&lang=js&"
export * from "./collection-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports